import * as React from 'react';
import styled from 'styled-components';

import { ReactComponent as SecurityIllustration } from '../../images/illustrations/illustration-security-and-control.svg';
import { INTERNAL_LINKS } from '../../utils';
import { Button, GradientHeader, Text } from '../design-system';
import { ToutWrapper } from '../design-system/ToutWrapper';
import { TextLockup } from '../global/TextLockup';

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px 0px 15px;
  border-top: 1px dashed ${({ theme }) => theme.borderColor.MUTED};
  border-bottom: 1px dashed ${({ theme }) => theme.borderColor.MUTED};
  z-index: 2;
  position: relative;
`;

const Inner = styled.div`
  display: flex;
  max-width: ${({ theme }) => theme.maxWidth.PAGE};
  padding: 40px;
  margin: 0 auto;
  z-index: 1;
  position: relative;
  width: 100%;
  max-width: 1070px;
  gap: 100px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    flex-direction: column;
    padding-bottom: 0;
  }
`;

const StyledHeading = styled(GradientHeader).attrs({
  $purple: true,
  renderAs: 'h1'
})`
  && {
    margin-bottom: 0;
  }
`;

const Left = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 50%;
  flex: 1 1 50%;
  max-width: 440px;
  position: relative;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    width: 100%;
    flex: 1 1 100%;
    max-width: none;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 40px;
`;

const Right = styled.div`
  width: 50%;
  flex: 1 1 50%;
  position: relative;
  z-index: 0;

  svg {
    position: absolute;
    top: -400px;
    left: -620px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    display: none;
  }
`;

const CONTENT = [
  {
    title: 'Flexible deployment models',
    description:
      'Multi-tenant, HIPAA, Single-Tenant, and Private Cloud options available'
  },
  {
    title: 'Easy authentication and authorization',
    description: 'SSO and SCIM with Google, AzureAD, Okta, and more'
  },
  {
    title: 'Secure database connections',
    description: 'SSL and pass-through OAuth available'
  }
];

export const SecurityTout: React.ComponentType = React.memo(() => {
  return (
    <ToutWrapper>
      <Top>
        <StyledHeading renderAs="h1">
          Built for security and control
        </StyledHeading>
      </Top>
      <Inner>
        <Left>
          <Text size="extra-large">
            Enterprise-grade security: SOC2, HIPAA, and privacy regulations.
          </Text>
          <Content>
            {CONTENT.map((item, index) => (
              <TextLockup
                key={index}
                description={item.description}
                title={item.title}
              />
            ))}
          </Content>
          <Button
            link={INTERNAL_LINKS.Security}
            text="Read more about Security"
          />
        </Left>
        <Right>
          <SecurityIllustration />
        </Right>
      </Inner>
    </ToutWrapper>
  );
});
